import { FC } from 'react';
import { LinkButton } from '../Button/LinkButton';
import { LogoCombinationMarkDarkImg, LogoCombinationMarkLightImg } from '../../assets';
import './Header.scss';
import { MenuButton } from 'components/MenuButton/MenuButton';

export type HeaderTheme = 'light' | 'dark' | 'glass';

type HeaderProps = {
  theme: HeaderTheme;
  showMobileNavigation: boolean;
  isMobileNavigationActive: boolean;
  logoLinkHref?: string;
  letsTalkLink: {
    url: string;
    onClick?: (e: React.MouseEvent) => void;
  };

  onToggleMobileNavigation?: () => void;
};

export const Header: FC<HeaderProps> = ({
  theme,
  showMobileNavigation,
  isMobileNavigationActive,
  letsTalkLink,
  logoLinkHref,
  onToggleMobileNavigation,
}) => {
  return (
    <div className='header-container'>
      <header className={`${theme} ${isMobileNavigationActive ? 'mobile-nav-active' : 'mobile-nav-inactive'}`}>
        <a href={logoLinkHref}>
          <img
            src={theme === 'light' || theme === 'glass' ? LogoCombinationMarkLightImg : LogoCombinationMarkDarkImg}
            alt='C4Workx logo'
          />
        </a>
        {showMobileNavigation ? (
          <MenuButton theme={theme} isActive={isMobileNavigationActive} onClick={() => onToggleMobileNavigation?.()} />
        ) : (
          <LinkButton
            text='Lets talk!'
            url={letsTalkLink.url}
            target='_self'
            font='regular'
            fill='hollow'
            color={theme === 'light' || theme === 'glass' ? 'white' : 'secondary'}
            onClick={letsTalkLink.onClick}
          />
        )}
      </header>
    </div>
  );
};
